var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Student } from '@/models/Student';
import { fileToBase64 } from '@/support/String';
import SelectFilter from '@/components/select-filter/SelectFilter';
import AsyncSelect from '@/components/async-select/AsyncSelect';
import { Group } from '@/models/Group';
import { Guardian } from '@/models/Guardian';
import ErrorHandler from '@/support/ErrorHandler';
import { User } from '@/models/User';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { RolesEnum } from '@/items/Roles';
let CreateDialog = class CreateDialog extends Vue {
    constructor() {
        super(...arguments);
        this.user = new User();
        this.student = new Student({
            avatar: '',
            first_name: '',
            middle_name: '',
            last_name: '',
            dob: '',
            email: '',
            level: '',
        });
        this.guardian = new Guardian();
        this.guardianModel = new Guardian();
        this.guardians = [];
        this.newGuardians = [];
        this.tempPassword = '';
        this.clearSelects = false;
        this.currentStep = 1;
        this.choice = '';
        this.isEditingDob = false;
        this.groupModel = new Group().sort('name');
        this.coachGroups = [];
        this.classGroups = [];
        this.selectedFile = null;
        this.isUploading = false;
        this.uploadResults = {
            success: [],
            updated: [],
            failed: {},
        };
        this.importHasFailed = false;
        this.failedResults = [];
    }
    mounted() {
        //
    }
    close() {
        if (this.tempPassword) {
            this.tempPassword = '';
        }
        this.$emit('input', false);
        this.$emit('userCreated');
        this.clearSelects = false;
        this.currentStep = 1;
    }
    avatarChanged(event) {
        if (event.target === null || event.target.files === null || !event.target.files.length) {
            return;
        }
        const file = event.target.files[0];
        fileToBase64(file).then((encodedFile) => {
            this.student.avatar = encodedFile;
        });
    }
    currentStepChanged(currentStep, previousStep) {
        if (currentStep === 5) {
            this.create();
        }
    }
    createGuardian() {
        this.guardian.roles = [RolesEnum.GUARDIAN];
        this.guardian.create().then((guardian) => {
            this.newGuardians.push({
                value: guardian.id,
                text: guardian.name,
            });
            this.guardian = new Guardian();
        });
    }
    createRelationships() {
        const relations = [];
        this.guardians.forEach((guardian) => {
            const relationship = {
                user: guardian.value,
                type: 'guardian',
            };
            relations.push(relationship);
        });
        this.newGuardians.forEach((guardian) => {
            const relationship = {
                user: guardian.value,
                type: 'guardian',
            };
            relations.push(relationship);
        });
        return relations;
    }
    create() {
        this.isUploading = true;
        this.choice === 'import' ? this.createFromExcel() : this.createUser();
    }
    createUser() {
        this.student.roles = [RolesEnum.STUDENT];
        const groups = [];
        this.coachGroups.forEach((group) => {
            groups.push(group.value);
        });
        this.student.groups = groups;
        this.student.relationships = this.createRelationships();
        this.student.level = this.student.level.value;
        this.student
            .create()
            .then((student) => {
            if (student.password) {
                this.tempPassword = student.password;
                this.isUploading = false;
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.currentStep = 1;
            this.isUploading = false;
        });
    }
    createFromExcel() {
        const payload = {
            excel: this.selectedFile,
            role: 'student',
        };
        this.student
            .create(payload)
            .then((results) => {
            this.uploadResults = results;
            this.isUploading = false;
            this.importHasFailed = !!this.uploadResults.failed.length;
            if (this.importHasFailed) {
                for (const key in this.uploadResults.failed) {
                    this.failedResults.push(this.uploadResults.failed[key]);
                }
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.currentStep = 1;
            this.isUploading = false;
        });
    }
    getTranslatedErrorValues(errors) {
        const translatedErrors = [];
        errors.forEach((error) => {
            const errorValue = Object.values(error)[0];
            const translatedError = this.$tc(`createDialog.finished.failed.errors.${errorValue}`);
            translatedErrors.push(translatedError);
        });
        return translatedErrors.join(', ');
    }
    onFileChange(event) {
        if (!event.target.files.length) {
            return;
        }
        this.selectedFile = event.target.files[0];
        if (!this.selectedFile) {
            return;
        }
        this.currentStep = 5;
    }
    get getFailedCount() {
        return Object.keys(this.uploadResults.failed).length;
    }
    clear() {
        this.student = new Student();
        this.guardian = new Guardian();
        this.newGuardians = [];
        this.guardians = [];
        this.clearSelects = true;
        this.$nextTick(() => {
            this.close();
        });
    }
};
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number]),
    __metadata("design:returntype", void 0)
], CreateDialog.prototype, "currentStepChanged", null);
CreateDialog = __decorate([
    Component({
        components: {
            AsyncSelect,
            SelectFilter,
            LoaderCard,
        },
    })
], CreateDialog);
export default CreateDialog;
